import { render, staticRenderFns } from "./safty-ailse.vue?vue&type=template&id=22c6a4ee&scoped=true"
import script from "./safty-ailse.vue?vue&type=script&lang=js"
export * from "./safty-ailse.vue?vue&type=script&lang=js"
import style0 from "./safty-ailse.vue?vue&type=style&index=0&id=22c6a4ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c6a4ee",
  null
  
)

export default component.exports